import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IFlightType } from 'src/models/flight-type.model';
import style from './flight-types-list.module.scss';
import FlightTypeAdd from '../flight-types-add/flight-types-add.component';
import FlightTypeEdit from '../flight-types-edit/flight-types-edit.component';
import FlightTypeDelete from '../flight-types-delete/flight-types-delete.component';

type IProp = {
  data: IFlightType[];
  loading: boolean;
};

const FlightTypeView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IFlightType>[] = [
    {
      title: Lang.LBL_FLIGHT_TYPE,
      index: 'flightType',
      width: '85%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <FlightTypeEdit data={value} />
          <FlightTypeDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as IFlightType, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_FLIGHT_TYPES} />
        <FlightTypeAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default FlightTypeView;
